const VITE_ENV = import.meta.env.VITE_ENV;
const isDevEnv = VITE_ENV.startsWith("development");
const isProdEnv = VITE_ENV.startsWith("production");
const isStartDev = VITE_ENV === "development.dev";
const isStartTest = VITE_ENV === "development.test";
const isBuildTest = VITE_ENV === "production.test";
const isBuildProd = VITE_ENV === "production.prod";
const isBuildProdDk = VITE_ENV === "production.prod-dk";

const isBuild = VITE_ENV === "production";
export { isDevEnv, isProdEnv, isStartDev, isStartTest, isBuildTest, isBuild, isBuildProd, isBuildProdDk };
